<template>
  <div class="p-4">
    <el-button icon="el-icon-close" size="small" v-if="showDeleteAll"
               @click="clearSelection()">Clear Selection</el-button>&nbsp;&nbsp;
    <el-button icon="el-icon-delete" type="danger" size="small" v-if="showDeleteAll"
               @click="deleteMultiple">Delete Selected</el-button>
    <button @click="$router.push('/ecommerce/orders/new')" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Order
    </button>
    <el-select @change="filterOrders()" v-model="filter.delivery_option" filterable placeholder="Please select Delivery Option">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-table
      ref="orderTable"
      :data="orders.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%"
      @select-all="handleAllRowSelection"
      @select="handleRowSelection">
      <el-table-column
        type="selection">
      </el-table-column>
      <el-table-column label="Customer" sortable>
        <template slot-scope="scope" v-if="scope.row.user">
          {{scope.row.user.first_name}} {{scope.row.user.last_name}}
        </template>
      </el-table-column>
      <el-table-column label="Qty" sortable>
        <template slot-scope="scope">{{scope.row.orderedItems.length}}</template>
      </el-table-column>
      <el-table-column prop="total" label="Total" sortable>
        <template slot-scope="scope">{{priceFormat(scope.row.total)}}</template>
      </el-table-column>
      <el-table-column label="Payment" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.delivery_option_id === paymentOption.HOME_DELIVERY || scope.row.delivery_option_id === paymentOption.PRE_PAID_OUTLET_PICKUP">
            <span v-if="scope.row.payment && scope.row.payment.failed === false">
              <el-tag size="mini" type="success">
                Paid Online via
              <span v-if="scope.row.payment">
                {{ scope.row.payment.paymentMethod.name }}
              </span>
              </el-tag><br>
              <span v-if="scope.row.delivery_option_id === paymentOption.HOME_DELIVERY"  style="font-size: 10px;">Home Delivery</span>
              <span v-if="scope.row.delivery_option_id === paymentOption.PRE_PAID_OUTLET_PICKUP"  style="font-size: 10px;">Pickup</span>
            </span>
            <span v-if="scope.row.payment && scope.row.payment.failed === true">
              <el-tag size="mini" type="error">Failed</el-tag>
            </span> <br >

          </span>
          <span v-if="scope.row.delivery_option_id === paymentOption.POST_PAID_OUTLET_PICKUP">
            <el-tag size="mini" type="warning">In-Store Payment</el-tag><br >
            <small style="font-size: 10px;">Pickup</small>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Status">
        <template slot-scope="scope">{{scope.row.status.name}}</template>
      </el-table-column>

      <el-table-column
        label="Delivered">
        <template slot-scope="scope">
          <span v-if="scope.row.delivered === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column label="Ordered">
        <template slot-scope="scope">
          <span v-if="scope.row.created_at">{{scope.row.created_at | moment("from") }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to filter"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="viewOrder(scope.row.id)" type="text" size="small">
            <i class="text-xl text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button v-if="false" @click="editOrder(scope.row.id)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteOrder(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-5 mb-5 float-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>

import { flatMap } from 'lodash';

export default {
  name: 'Orders',
  data() {
    return {
      search: '',
      page: 1,
      limit: 20,
      showDeleteAll: false,
      filter: {
        delivery_option: null,
        outlet: null,
      },
      paymentOption:{
        HOME_DELIVERY: 1,
        PRE_PAID_OUTLET_PICKUP: 2,
        POST_PAID_OUTLET_PICKUP: 3,
      },
      options: [
        {
          label: 'Home Delivery',
          value: 1
        },
        {
          label: 'PrePaid Pickup',
          value: 2
        },
        {
          label: 'PostPaid Pickup',
          value: 3
        },
        {
          label: 'All',
          value: null
        },
      ]

    };
  },
  computed: {
    orders() {
      return flatMap(this.$store.state.OrderModule.orders);
    },
    pagination() {
      return this.$store.state.OrderModule.pagination;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    handleRowSelection() {
      this.showDeleteAll = this.$refs.orderTable.selection.length > 0;
    },
    handleAllRowSelection() {
      this.showDeleteAll = this.$refs.orderTable.selection.length > 0;
    },
    clearSelection() {
      this.$refs.orderTable.clearSelection();
      this.showDeleteAll = false;
    },
    viewOrder(id) {
      this.$router.push(`/ecommerce/orders/${id}/details`);
    },
    editOrder(id) {
      this.$router.push(`/ecommerce/orders/${id}/edit`);
    },
    deleteOrder(orderId) {
      this.$confirm('Are you sure you want to delete this order?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OrderModule/deleteOrder', { orderId });
          this.$notify.success({
            title: 'Success',
            message: 'Order has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    deleteMultiple() {
      const selected = this.$refs.orderTable.selection.map(order => order.id);
      this.$confirm('Are you sure you want to delete this orders?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          selected.forEach((orderId) => {
            this.$store.dispatch('OrderModule/deleteOrder', { orderId });
          });
          this.$notify.success({
            title: 'Success',
            message: 'Orders has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
        this.clearSelection();
      });
    },
    getOrders(options = null) {
      try {
        this.$store.dispatch('OrderModule/fetchAllOrders', { page: this.page, limit: this.limit, options });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    handleSizeChange(args) {
      this.limit = args;
      this.getOrders();
    },
    handlePageChange(args) {
      this.page = args;
      this.getOrders();
    },
    filterOrders() {
      const options = {
        delivery_option_id: this.filter.delivery_option,
      };

      this.getOrders(options);
    },
  },
};
</script>

<style scoped>

</style>
